import * as React from 'react';
import { ChartComponentProps, Pie } from 'react-chartjs-2';
import { ChartWrapper } from '../ChartWrapper';
import { DefaultChartProps } from '../DefaultChartProps';

export interface ChartablePieDataItem {
    label: string;
    value: number;
    colour: string;
}

export interface ChartablePieData<T extends ChartablePieDataItem = ChartablePieDataItem> {
    data: T[];
}

export function toChartablePieData<T, U extends ChartablePieDataItem>(
    obj: T | null | undefined,
    mappingFunc: (data: T) => ChartablePieData<U>,
): ChartablePieData<U> | null {
    return obj ? mappingFunc(obj) : null;
}

export interface PieChartProps extends DefaultChartProps {
    data: ChartablePieData;
    options?: ChartComponentProps['options'];
}

export const PieChart: React.FC<PieChartProps> = ({ data: { data }, options, ...props }) => (
    <ChartWrapper>
        <Pie
            data={{
                datasets: [
                    {
                        backgroundColor: data.map(chartable => chartable.colour),
                        data: data.map(chartable => chartable.value),
                    },
                ],
                labels: data.map(chartable => chartable.label),
            }}
            legend={{
                display: false,
            }}
            options={options}
            {...props}
        />
    </ChartWrapper>
);
